import React, { Component } from 'react';
import { connect } from 'react-redux';

// API
import * as API  from '../../utils/api';

// Components
import CategoryCards from '../../components/ResourceLibrary/CategoryCards';
import AppCanvasLoader from '../../components/Global/AppCanvasLoader';

class ResourceLibraryOverview extends Component {

  state = {
    categories: [],
    isLoading: true,
    disabled: false,
  }

  componentDidMount() {
    this.loadResourceLibraryCategories(this.props)
  }

  loadResourceLibraryCategories(props) {
    const { user } = props;

    API.getResourceLibraryCategories(user).then(response => {
      if (response.errors) {
        this.setState({
          disabled: true,
          isLoading: false,
        })
      } else {
        this.setState({
          categories: response,
          isLoading: false,
        })
      }
    });
  }

  renderContent() {
    const { disabled, categories } = this.state;

    return disabled
    ? (
      <div>
        The Resource Library is currently unavailable. Please <a href="https://lockerlinked.com/feedback" rel="noopener noreferrer" target="_blank">contact us</a> if this error persists.
      </div>
    ) : (
      <CategoryCards categories={categories} />
    )
  }

  render() {
    const {
      isLoading,
    } = this.state;

    return (
      <section className="resource-library-overview">
        <h2>Resource Library</h2>
        { isLoading
          ? (
            <AppCanvasLoader />
          )
          : this.renderContent()
        }
      </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps,
  null
)(ResourceLibraryOverview)



// WEBPACK FOOTER //
// ./src/components/ResourceLibrary/ResourceLibraryOverview.js